import { QueryUtils } from '../../Util/QueryUtils';
import { ServiceSearchParams } from '@ibe/components';
import CmsPackage from '../../Models/CMS/CmsPackage';
import { ActivePackageConfiguration, DealFinderWidgetModeProps } from './DealFinderProps';

class DealFinderPropsResolver {
  private _isInWidgetMode?: boolean;

  private _query: URLSearchParams;

  private _searchParams?: Partial<ServiceSearchParams>;

  constructor(
    isInWidgetMode: boolean | undefined,
    query: URLSearchParams,
    searchParams: Partial<ServiceSearchParams> | undefined
  ) {
    this._query = query;
    this._isInWidgetMode = isInWidgetMode;
    this._searchParams = searchParams;
  }

  get isInWidgetMode(): boolean {
    return !!this._isInWidgetMode;
  }

  set isInWidgetMode(value: boolean) {
    this._isInWidgetMode = value;
  }

  get query(): URLSearchParams {
    return this._query;
  }

  set query(value: URLSearchParams) {
    this._query = value;
  }

  get searchParams(): Partial<ServiceSearchParams> | undefined {
    return this._searchParams;
  }

  set searchParams(value: Partial<ServiceSearchParams> | undefined) {
    this._searchParams = value;
  }

  // ==================================================================================================================

  getResolvedPackageSalesChannelCode(
    activePackageConfigurationFromProps?: ActivePackageConfiguration,
    activePackageConfiguration?: ActivePackageConfiguration
  ): string {
    let resolvedPackageSalesChannelCode =
      this.searchParams?.salesChannelCode ?? QueryUtils.getSalesChannelCode(this.query);

    if (activePackageConfigurationFromProps?.activePackageSalesChannelCode) {
      resolvedPackageSalesChannelCode =
        activePackageConfigurationFromProps.activePackageSalesChannelCode;
    } else if (activePackageConfiguration?.activePackageSalesChannelCode) {
      resolvedPackageSalesChannelCode = activePackageConfiguration.activePackageSalesChannelCode;
    }

    return resolvedPackageSalesChannelCode ?? '';
  }

  getResolvedPackageCode(
    activePackageConfigurationFromProps?: ActivePackageConfiguration,
    activePackageConfiguration?: ActivePackageConfiguration
  ): string {
    let resolvedPackageCode = this.searchParams?.code ?? QueryUtils.getPackageCode(this.query);

    if (activePackageConfigurationFromProps?.activePackageModel?.name) {
      resolvedPackageCode = activePackageConfigurationFromProps.activePackageModel.name;
    } else if (activePackageConfiguration?.activePackageModel?.name) {
      resolvedPackageCode = activePackageConfiguration.activePackageModel.name;
    }
    return resolvedPackageCode ?? '';
  }

  getResolvedExpandDateSelection(
    packageModel?: CmsPackage,
    dealFinderWidgetModeProps?: DealFinderWidgetModeProps
  ): boolean {
    if (this.isInWidgetMode) {
      return !!dealFinderWidgetModeProps?.expandDateSelection;
    } else {
      return !!packageModel?.dealFinderConfig?.expandDateSelection;
    }
  }

  getResolvedExpandPaxSelection(
    packageModel?: CmsPackage,
    dealFinderWidgetModeProps?: DealFinderWidgetModeProps
  ): boolean {
    if (this.isInWidgetMode) {
      return !!dealFinderWidgetModeProps?.expandPaxSelection;
    } else {
      return !!packageModel?.dealFinderConfig?.expandPaxSelection;
    }
  }

  getResolvedExpandHotelSelection(
    packageModel?: CmsPackage,
    dealFinderWidgetModeProps?: DealFinderWidgetModeProps
  ): boolean {
    if (this.isInWidgetMode) {
      return !!dealFinderWidgetModeProps?.expandHotelSelection;
    } else {
      return !!packageModel?.dealFinderConfig?.expandHotelSelection;
    }
  }

  getResolvedUseDealFinder(useDealFinder: boolean, packageModel?: CmsPackage): boolean {
    if (useDealFinder) {
      return true;
    }

    return !!packageModel?.dealFinderConfig?.useDealFinder;
  }
}

export default DealFinderPropsResolver;
